import fetch from 'isomorphic-fetch';
import BaseApi from '../../../../shared/javascripts/api/BaseApi'

class UserProgressApi extends BaseApi {
  static fetchOverallScore(filterOptions) {
    return fetch(this.buildRequest(`/v1/gen_ops/progresses/summary.json?user_id=${filterOptions.user_id}&team_id=${filterOptions.team_id}&from_date=${filterOptions.from_date}&to_date=${filterOptions.to_date}`))
  }

  static fetchOverallMistakes(typeName, filterOptions) {
    const url = () => {
      switch(typeName) {
      case 'Category':
        return '/v1/gen_ops/progresses/distribution_by_category.json'
      case 'Group':
        return '/v1/gen_ops/progresses/distribution_by_group.json'
      case 'Genre':
        return '/v1/gen_ops/progresses/distribution_by_datapoint.json'
      case 'Value':
        return '/v1/gen_ops/progresses/distribution_by_value_option.json'
      default:
        return '/v1/gen_ops/progresses/distribution_by_category.json'
      }
    }
    return fetch(this.buildRequest(`${url()}?user_id=${filterOptions.user_id}&team_id=${filterOptions.team_id}&from_date=${filterOptions.from_date}&to_date=${filterOptions.to_date}`))
  }

  static fetchGenreScore(filterOptions) {
    return fetch(this.buildRequest(`/v1/gen_ops/progresses/distribution_by_genre.json?user_id=${filterOptions.user_id}&team_id=${filterOptions.team_id}&from_date=${filterOptions.from_date}&to_date=${filterOptions.to_date}`))
  }
}

export default UserProgressApi



// WEBPACK FOOTER //
// ./src/reports/general/javascripts/api/UserProgressApi.js